import { QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Carousel, Modal } from "antd";
import React, { useState } from "react";

import "./style.scss";

const SizeModal = ({ sizeImages, productName }: any) => {
  const [visible, setVisible] = useState(false);

  const openModal = () => {
    setVisible(true);
  };
  const closeModal = () => {
    setVisible(false);
  };

  return (
    <>
      <Button
        className="foam-button"
        icon={<QuestionCircleOutlined />}
        onClick={openModal}
      />

      <Modal
        className="size-image-modal"
        visible={visible}
        onCancel={closeModal}
        title={`Hình vẽ mô tả kích thước ${productName}`}
        footer={null}
        width={1000}>
        <Carousel autoplay className="size-images-slider">
          {sizeImages.map((item: string) => (
            <img src={item} alt="" />
          ))}
        </Carousel>
      </Modal>
    </>
  );
};

export default SizeModal;
